import { configureStore } from '@reduxjs/toolkit'
import listTemplate from './slices/list-tempate'

let store = configureStore({
    reducer:{
        listTemplate,
    }
})

export default store